import { TReturnType } from '@r1-frontend/service-engineer-visit';

import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { IAction } from '~/src/store';

type TTimeSlot = Omit<TReturnType, 'deliveryType' | 'deliveryCost'>

const setSelectedTimeSlot = (timeSlot: TTimeSlot): IAction<EAction.SetSelectedTimeSlot, { timeSlot: TTimeSlot }> => ({
    type: EAction.SetSelectedTimeSlot,
    payload: {
        timeSlot,
    },
});

export default setSelectedTimeSlot;
